import * as Mod1 from "./discourse/components/custom-field-input";
import * as Mod2 from "./discourse/components/custom-user-selector";
import * as Mod3 from "./discourse/components/custom-wizard-category-selector";
import * as Mod4 from "./discourse/components/custom-wizard-category-settings";
import * as Mod5 from "./discourse/components/custom-wizard-composer-editor";
import * as Mod6 from "./discourse/components/custom-wizard-date-input";
import * as Mod7 from "./discourse/components/custom-wizard-date-time-input";
import * as Mod8 from "./discourse/components/custom-wizard-field-category";
import * as Mod9 from "./discourse/components/custom-wizard-field-checkbox";
import * as Mod10 from "./discourse/components/custom-wizard-field-composer-preview";
import * as Mod11 from "./discourse/components/custom-wizard-field-composer";
import * as Mod12 from "./discourse/components/custom-wizard-field-date-time";
import * as Mod13 from "./discourse/components/custom-wizard-field-date";
import * as Mod14 from "./discourse/components/custom-wizard-field-dropdown";
import * as Mod15 from "./discourse/components/custom-wizard-field-group";
import * as Mod16 from "./discourse/components/custom-wizard-field-number";
import * as Mod17 from "./discourse/components/custom-wizard-field-tag";
import * as Mod18 from "./discourse/components/custom-wizard-field-text";
import * as Mod19 from "./discourse/components/custom-wizard-field-textarea";
import * as Mod20 from "./discourse/components/custom-wizard-field-time";
import * as Mod21 from "./discourse/components/custom-wizard-field-topic";
import * as Mod22 from "./discourse/components/custom-wizard-field-upload";
import * as Mod23 from "./discourse/components/custom-wizard-field-url";
import * as Mod24 from "./discourse/components/custom-wizard-field-user-selector";
import * as Mod25 from "./discourse/components/custom-wizard-field";
import * as Mod26 from "./discourse/components/custom-wizard-group-selector";
import * as Mod27 from "./discourse/components/custom-wizard-no-access";
import * as Mod28 from "./discourse/components/custom-wizard-similar-topic";
import * as Mod29 from "./discourse/components/custom-wizard-similar-topics";
import * as Mod30 from "./discourse/components/custom-wizard-step-form";
import * as Mod31 from "./discourse/components/custom-wizard-step";
import * as Mod32 from "./discourse/components/custom-wizard-tag-chooser";
import * as Mod33 from "./discourse/components/custom-wizard-text-field";
import * as Mod34 from "./discourse/components/custom-wizard-textarea-editor";
import * as Mod35 from "./discourse/components/custom-wizard-time-input";
import * as Mod36 from "./discourse/components/custom-wizard-topic-selector";
import * as Mod37 from "./discourse/components/field-validators";
import * as Mod38 from "./discourse/components/modal/admin-wizards-columns";
import * as Mod39 from "./discourse/components/modal/next-session-scheduled";
import * as Mod40 from "./discourse/components/similar-topics-validator";
import * as Mod41 from "./discourse/components/validator";
import * as Mod42 from "./discourse/components/wizard-custom-action";
import * as Mod43 from "./discourse/components/wizard-custom-field";
import * as Mod44 from "./discourse/components/wizard-custom-step";
import * as Mod45 from "./discourse/components/wizard-links";
import * as Mod46 from "./discourse/components/wizard-mapper-connector";
import * as Mod47 from "./discourse/components/wizard-mapper-input";
import * as Mod48 from "./discourse/components/wizard-mapper-pair";
import * as Mod49 from "./discourse/components/wizard-mapper-selector-type";
import * as Mod50 from "./discourse/components/wizard-mapper-selector";
import * as Mod51 from "./discourse/components/wizard-mapper";
import * as Mod52 from "./discourse/components/wizard-message";
import * as Mod53 from "./discourse/components/wizard-realtime-validations";
import * as Mod54 from "./discourse/components/wizard-subscription-selector";
import * as Mod55 from "./discourse/components/wizard-subscription-selector/wizard-subscription-selector-header";
import * as Mod56 from "./discourse/components/wizard-subscription-selector/wizard-subscription-selector-row";
import * as Mod57 from "./discourse/components/wizard-table-field";
import * as Mod58 from "./discourse/components/wizard-text-editor";
import * as Mod59 from "./discourse/components/wizard-user-chooser";
import * as Mod60 from "./discourse/components/wizard-user-chooser/wizard-user-chooser-row";
import * as Mod61 from "./discourse/components/wizard-value-list";
import * as Mod62 from "./discourse/connectors/admin-menu/wizards-nav-button.gjs";
import * as Mod63 from "./discourse/connectors/admin-user-details/admin-user-wizard-details.gjs";
import * as Mod64 from "./discourse/connectors/category-custom-settings/custom-wizard-category-settings.gjs";
import * as Mod65 from "./discourse/connectors/top-notices/prompt-completion.gjs";
import * as Mod66 from "./discourse/controllers/admin-wizards-api-show";
import * as Mod67 from "./discourse/controllers/admin-wizards-custom-fields";
import * as Mod68 from "./discourse/controllers/admin-wizards-logs-show";
import * as Mod69 from "./discourse/controllers/admin-wizards-logs";
import * as Mod70 from "./discourse/controllers/admin-wizards-manager";
import * as Mod71 from "./discourse/controllers/admin-wizards-submissions-show";
import * as Mod72 from "./discourse/controllers/admin-wizards-submissions";
import * as Mod73 from "./discourse/controllers/admin-wizards-wizard-show";
import * as Mod74 from "./discourse/controllers/admin-wizards-wizard";
import * as Mod75 from "./discourse/controllers/admin-wizards";
import * as Mod76 from "./discourse/controllers/custom-wizard-step";
import * as Mod77 from "./discourse/controllers/custom-wizard";
import * as Mod78 from "./discourse/controllers/custom-wizard/index";
import * as Mod79 from "./discourse/custom-wizard-admin-route-map";
import * as Mod80 from "./discourse/custom-wizard-route-map";
import * as Mod81 from "./discourse/helpers/wizard-char-counter";
import * as Mod82 from "./discourse/initializers/custom-wizard-dynamic-schema";
import * as Mod83 from "./discourse/initializers/custom-wizard-edits";
import * as Mod84 from "./discourse/initializers/custom-wizard-redirect";
import * as Mod85 from "./discourse/lib/wizard-json";
import * as Mod86 from "./discourse/lib/wizard-mapper";
import * as Mod87 from "./discourse/lib/wizard-schema";
import * as Mod88 from "./discourse/lib/wizard-submission";
import * as Mod89 from "./discourse/lib/wizard";
import * as Mod90 from "./discourse/mixins/subscription";
import * as Mod91 from "./discourse/mixins/undo-changes";
import * as Mod92 from "./discourse/mixins/valid-state";
import * as Mod93 from "./discourse/models/custom-wizard-admin";
import * as Mod94 from "./discourse/models/custom-wizard-api";
import * as Mod95 from "./discourse/models/custom-wizard-custom-field";
import * as Mod96 from "./discourse/models/custom-wizard-field";
import * as Mod97 from "./discourse/models/custom-wizard-logs";
import * as Mod98 from "./discourse/models/custom-wizard-manager";
import * as Mod99 from "./discourse/models/custom-wizard-step";
import * as Mod100 from "./discourse/models/custom-wizard";
import * as Mod101 from "./discourse/routes/admin-wizards-api-show";
import * as Mod102 from "./discourse/routes/admin-wizards-api";
import * as Mod103 from "./discourse/routes/admin-wizards-custom-fields";
import * as Mod104 from "./discourse/routes/admin-wizards-logs-show";
import * as Mod105 from "./discourse/routes/admin-wizards-logs";
import * as Mod106 from "./discourse/routes/admin-wizards-manager";
import * as Mod107 from "./discourse/routes/admin-wizards-submissions-show";
import * as Mod108 from "./discourse/routes/admin-wizards-submissions";
import * as Mod109 from "./discourse/routes/admin-wizards-wizard-show";
import * as Mod110 from "./discourse/routes/admin-wizards-wizard";
import * as Mod111 from "./discourse/routes/admin-wizards";
import * as Mod112 from "./discourse/routes/custom-wizard-step";
import * as Mod113 from "./discourse/routes/custom-wizard";
import * as Mod114 from "./discourse/routes/custom-wizard/index";
import * as Mod115 from "./discourse/services/subscription";
import * as Mod116 from "./discourse/templates/admin-wizards-api-show";
import * as Mod117 from "./discourse/templates/admin-wizards-api";
import * as Mod118 from "./discourse/templates/admin-wizards-custom-fields";
import * as Mod119 from "./discourse/templates/admin-wizards-logs-show";
import * as Mod120 from "./discourse/templates/admin-wizards-logs";
import * as Mod121 from "./discourse/templates/admin-wizards-manager";
import * as Mod122 from "./discourse/templates/admin-wizards-submissions-show";
import * as Mod123 from "./discourse/templates/admin-wizards-submissions";
import * as Mod124 from "./discourse/templates/admin-wizards-wizard-show";
import * as Mod125 from "./discourse/templates/admin-wizards-wizard";
import * as Mod126 from "./discourse/templates/custom-wizard-step";
import * as Mod127 from "./discourse/templates/custom-wizard";
import * as Mod128 from "./discourse/templates/custom-wizard/index";
const compatModules = {
  "discourse/components/custom-field-input": Mod1,
  "discourse/components/custom-user-selector": Mod2,
  "discourse/components/custom-wizard-category-selector": Mod3,
  "discourse/components/custom-wizard-category-settings": Mod4,
  "discourse/components/custom-wizard-composer-editor": Mod5,
  "discourse/components/custom-wizard-date-input": Mod6,
  "discourse/components/custom-wizard-date-time-input": Mod7,
  "discourse/components/custom-wizard-field-category": Mod8,
  "discourse/components/custom-wizard-field-checkbox": Mod9,
  "discourse/components/custom-wizard-field-composer-preview": Mod10,
  "discourse/components/custom-wizard-field-composer": Mod11,
  "discourse/components/custom-wizard-field-date-time": Mod12,
  "discourse/components/custom-wizard-field-date": Mod13,
  "discourse/components/custom-wizard-field-dropdown": Mod14,
  "discourse/components/custom-wizard-field-group": Mod15,
  "discourse/components/custom-wizard-field-number": Mod16,
  "discourse/components/custom-wizard-field-tag": Mod17,
  "discourse/components/custom-wizard-field-text": Mod18,
  "discourse/components/custom-wizard-field-textarea": Mod19,
  "discourse/components/custom-wizard-field-time": Mod20,
  "discourse/components/custom-wizard-field-topic": Mod21,
  "discourse/components/custom-wizard-field-upload": Mod22,
  "discourse/components/custom-wizard-field-url": Mod23,
  "discourse/components/custom-wizard-field-user-selector": Mod24,
  "discourse/components/custom-wizard-field": Mod25,
  "discourse/components/custom-wizard-group-selector": Mod26,
  "discourse/components/custom-wizard-no-access": Mod27,
  "discourse/components/custom-wizard-similar-topic": Mod28,
  "discourse/components/custom-wizard-similar-topics": Mod29,
  "discourse/components/custom-wizard-step-form": Mod30,
  "discourse/components/custom-wizard-step": Mod31,
  "discourse/components/custom-wizard-tag-chooser": Mod32,
  "discourse/components/custom-wizard-text-field": Mod33,
  "discourse/components/custom-wizard-textarea-editor": Mod34,
  "discourse/components/custom-wizard-time-input": Mod35,
  "discourse/components/custom-wizard-topic-selector": Mod36,
  "discourse/components/field-validators": Mod37,
  "discourse/components/modal/admin-wizards-columns": Mod38,
  "discourse/components/modal/next-session-scheduled": Mod39,
  "discourse/components/similar-topics-validator": Mod40,
  "discourse/components/validator": Mod41,
  "discourse/components/wizard-custom-action": Mod42,
  "discourse/components/wizard-custom-field": Mod43,
  "discourse/components/wizard-custom-step": Mod44,
  "discourse/components/wizard-links": Mod45,
  "discourse/components/wizard-mapper-connector": Mod46,
  "discourse/components/wizard-mapper-input": Mod47,
  "discourse/components/wizard-mapper-pair": Mod48,
  "discourse/components/wizard-mapper-selector-type": Mod49,
  "discourse/components/wizard-mapper-selector": Mod50,
  "discourse/components/wizard-mapper": Mod51,
  "discourse/components/wizard-message": Mod52,
  "discourse/components/wizard-realtime-validations": Mod53,
  "discourse/components/wizard-subscription-selector": Mod54,
  "discourse/components/wizard-subscription-selector/wizard-subscription-selector-header": Mod55,
  "discourse/components/wizard-subscription-selector/wizard-subscription-selector-row": Mod56,
  "discourse/components/wizard-table-field": Mod57,
  "discourse/components/wizard-text-editor": Mod58,
  "discourse/components/wizard-user-chooser": Mod59,
  "discourse/components/wizard-user-chooser/wizard-user-chooser-row": Mod60,
  "discourse/components/wizard-value-list": Mod61,
  "discourse/connectors/admin-menu/wizards-nav-button": Mod62,
  "discourse/connectors/admin-user-details/admin-user-wizard-details": Mod63,
  "discourse/connectors/category-custom-settings/custom-wizard-category-settings": Mod64,
  "discourse/connectors/top-notices/prompt-completion": Mod65,
  "discourse/controllers/admin-wizards-api-show": Mod66,
  "discourse/controllers/admin-wizards-custom-fields": Mod67,
  "discourse/controllers/admin-wizards-logs-show": Mod68,
  "discourse/controllers/admin-wizards-logs": Mod69,
  "discourse/controllers/admin-wizards-manager": Mod70,
  "discourse/controllers/admin-wizards-submissions-show": Mod71,
  "discourse/controllers/admin-wizards-submissions": Mod72,
  "discourse/controllers/admin-wizards-wizard-show": Mod73,
  "discourse/controllers/admin-wizards-wizard": Mod74,
  "discourse/controllers/admin-wizards": Mod75,
  "discourse/controllers/custom-wizard-step": Mod76,
  "discourse/controllers/custom-wizard": Mod77,
  "discourse/controllers/custom-wizard/index": Mod78,
  "discourse/custom-wizard-admin-route-map": Mod79,
  "discourse/custom-wizard-route-map": Mod80,
  "discourse/helpers/wizard-char-counter": Mod81,
  "discourse/initializers/custom-wizard-dynamic-schema": Mod82,
  "discourse/initializers/custom-wizard-edits": Mod83,
  "discourse/initializers/custom-wizard-redirect": Mod84,
  "discourse/lib/wizard-json": Mod85,
  "discourse/lib/wizard-mapper": Mod86,
  "discourse/lib/wizard-schema": Mod87,
  "discourse/lib/wizard-submission": Mod88,
  "discourse/lib/wizard": Mod89,
  "discourse/mixins/subscription": Mod90,
  "discourse/mixins/undo-changes": Mod91,
  "discourse/mixins/valid-state": Mod92,
  "discourse/models/custom-wizard-admin": Mod93,
  "discourse/models/custom-wizard-api": Mod94,
  "discourse/models/custom-wizard-custom-field": Mod95,
  "discourse/models/custom-wizard-field": Mod96,
  "discourse/models/custom-wizard-logs": Mod97,
  "discourse/models/custom-wizard-manager": Mod98,
  "discourse/models/custom-wizard-step": Mod99,
  "discourse/models/custom-wizard": Mod100,
  "discourse/routes/admin-wizards-api-show": Mod101,
  "discourse/routes/admin-wizards-api": Mod102,
  "discourse/routes/admin-wizards-custom-fields": Mod103,
  "discourse/routes/admin-wizards-logs-show": Mod104,
  "discourse/routes/admin-wizards-logs": Mod105,
  "discourse/routes/admin-wizards-manager": Mod106,
  "discourse/routes/admin-wizards-submissions-show": Mod107,
  "discourse/routes/admin-wizards-submissions": Mod108,
  "discourse/routes/admin-wizards-wizard-show": Mod109,
  "discourse/routes/admin-wizards-wizard": Mod110,
  "discourse/routes/admin-wizards": Mod111,
  "discourse/routes/custom-wizard-step": Mod112,
  "discourse/routes/custom-wizard": Mod113,
  "discourse/routes/custom-wizard/index": Mod114,
  "discourse/services/subscription": Mod115,
  "discourse/templates/admin-wizards-api-show": Mod116,
  "discourse/templates/admin-wizards-api": Mod117,
  "discourse/templates/admin-wizards-custom-fields": Mod118,
  "discourse/templates/admin-wizards-logs-show": Mod119,
  "discourse/templates/admin-wizards-logs": Mod120,
  "discourse/templates/admin-wizards-manager": Mod121,
  "discourse/templates/admin-wizards-submissions-show": Mod122,
  "discourse/templates/admin-wizards-submissions": Mod123,
  "discourse/templates/admin-wizards-wizard-show": Mod124,
  "discourse/templates/admin-wizards-wizard": Mod125,
  "discourse/templates/custom-wizard-step": Mod126,
  "discourse/templates/custom-wizard": Mod127,
  "discourse/templates/custom-wizard/index": Mod128,
};
export default compatModules;
